import { useMutation } from "@tanstack/react-query";
import { createRoles as apiCreateRoles } from "../../api/apiRoles";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateRoles() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: createRoles,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiCreateRoles(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/roles');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createRoles, results };
}
